var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.3569C14.1944 17.3569 18 13.6157 18 9.00073C18 4.38573 14.1944 0.644531 9.5 0.644531C4.80558 0.644531 1 4.38573 1 9.00073C1 13.6157 4.80558 17.3569 9.5 17.3569Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49968 5.48286L6.13111 8.26086M9.49968 5.48286L12.8682 8.26086M9.49968 5.48286V2.9773M6.13111 8.26086L7.02051 11.787M6.13111 8.26086L3.79051 7.28597M7.02051 11.787H11.9788M7.02051 11.787L5.78093 13.8761M11.9788 11.787L12.8682 8.26086M11.9788 11.787L13.2184 13.8761L11.9788 16.9661M12.8682 8.26086L15.2088 7.28597M15.2088 7.28597L16.3501 4.09756M15.2088 7.28597L17.9554 9.6096M3.79051 7.28597L2.64921 4.09756M3.79051 7.28597L1.04395 9.6096M9.49968 2.9773L12.333 1.12153M9.49968 2.9773L6.66634 1.12109M16.3501 13.8761H13.307M5.78093 13.8761L7.03689 16.9879M5.78093 13.8761H2.66559",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSport);
export default __webpack_public_path__ + "static/media/sport.59c0533da625ed8d5a0aa4e4e7c6076c.svg";
export { ForwardRef as ReactComponent };